/* Scroll reveal for the gmj sections. Progressive enhancement only:
   bails for reduced-motion visitors and old browsers, so content is
   never hidden unless this script is running and will reveal it. */
(function () {
  if (window.Shopify && window.Shopify.designMode) {
    /* Theme editor: show everything immediately so previews are never blank. */
    document.querySelectorAll('.gmj-head, .gmj-card, .gmj-feat, .gmj-story-txt, .gmj-pe-col').forEach(function (t) { t.classList.add('is-in'); });
    return;
  }
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var targets = document.querySelectorAll(
    '.gmj-head, .gmj-card, .gmj-feat, .gmj-story-txt, .gmj-pe-col'
  );
  if (!targets.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  targets.forEach(function (t) {
    /* Skip anything already in view on load — no pop-in above the fold. */
    var r = t.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) { t.classList.add('is-in'); return; }
    t.classList.add('gmj-rv');
    io.observe(t);
  });
})();

/* Add-to-bag confirmation: swap the buy button label to a checkmark
   for a moment. Feedback, not motion — works with reduced motion on. */
document.addEventListener('click', function (e) {
  var b = e.target.closest('.product-form__submit, .quick-add__submit, .gmj-stickybuy__btn');
  if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
  b.classList.add('gmj-added');
  /* Long enough to cover the cart round-trip from Qatar (~1.5-2s) so the
     button never goes blank before the drawer opens. */
  setTimeout(function () { b.classList.remove('gmj-added'); }, 3000);
});

/* Hero sparkle parallax. The whole sparkle layer shifts as you scroll,
   never the individual sparks — their twinkle animation owns their own
   transform, so animating the parent is what keeps the two from fighting. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var layer = document.querySelector('.gmj-hero-sparks');
  if (!layer) return;
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      if (document.documentElement.classList.contains('gmj-fx-paused')) return;
      layer.style.transform = 'translateY(' + (window.scrollY * 0.22) + 'px)';
    });
  }, { passive: true });
})();

/* Card tilt + gloss glare: the card leans toward the cursor and a soft
   light spot tracks it, like light moving on wet gloss. Pointer devices
   only, and the global pause class stops it. */
(function () {
  if (!window.matchMedia('(any-pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('.gmj-card-wrap').forEach(function (card) {
    card.addEventListener('pointermove', function (e) {
      if (document.documentElement.classList.contains('gmj-fx-paused')) return;
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      card.style.setProperty('--ry', ((x - 0.5) * 10).toFixed(2) + 'deg');
      card.style.setProperty('--rx', ((0.5 - y) * 8).toFixed(2) + 'deg');
      card.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
      card.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      card.classList.add('gmj-tilting');
    });
    card.addEventListener('pointerleave', function () {
      card.classList.remove('gmj-tilting');
    });
  });
})();

/* Cart badge pop + odometer roll: when Dawn re-renders the cart bubble
   after an add, the badge springs and the count rolls to its new value
   like an odometer digit. The muting flag stops the observer reacting
   to the DOM edits the roll itself makes. */
(function () {
  var bubble = document.getElementById('cart-icon-bubble');
  if (!bubble || !('MutationObserver' in window)) return;
  var last = null, scheduled = false;
  function countSpan() { return bubble.querySelector('.cart-count-bubble span[aria-hidden]'); }
  var s0 = countSpan();
  if (s0) last = s0.textContent.trim();
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    /* Dawn re-renders the bubble more than once per add — let the current
       render task finish, then animate the DOM that will actually stay on
       screen. setTimeout(0), not rAF: rAF never fires in background tabs. */
    setTimeout(function () {
      scheduled = false;
      var span = countSpan();
      if (!span) { last = null; return; }
      var rolling = span.querySelector('.gmj-odo');
      if (rolling) { /* our own edit re-fired the observer — sync last to the roll target */
        var tgt = rolling.lastElementChild;
        if (tgt) last = tgt.textContent.trim();
        return;
      }
      var next = span.textContent.trim();
      if (next !== last) { /* pop only on a real change — never twice per add */
        bubble.classList.remove('gmj-pop');
        void bubble.offsetWidth;
        bubble.classList.add('gmj-pop');
      }
      if (last !== null && next !== last && next.length < 4 &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        span.innerHTML = '<span class="gmj-odo"><span>' + last + '</span><span>' + next + '</span></span>';
        var odo = span.firstChild;
        setTimeout(function () { odo.classList.add('gmj-odo-go'); }, 20);
        setTimeout(function () {
          if (span.isConnected && span.querySelector('.gmj-odo')) span.textContent = next;
        }, 380);
      }
      last = next;
    }, 0);
  }).observe(bubble, { childList: true, subtree: true });
})();

/* Magnetic CTA buttons: desktop pointers only — buttons lean gently
   toward the cursor and settle back on leave. */
(function () {
  if (!window.matchMedia('(any-pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = '.btn, .gmj-qa-btn, .product-form__submit, .quick-add__submit, .gmj-stickybuy__btn';
  var cur = null;
  document.addEventListener('pointermove', function (e) {
    var b = e.target.closest ? e.target.closest(SEL) : null;
    if (cur && cur !== b) { cur.style.transform = ''; cur = null; }
    if (!b || document.documentElement.classList.contains('gmj-fx-paused')) return;
    var r = b.getBoundingClientRect();
    var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
    var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
    b.classList.add('gmj-mag');
    b.style.transform = 'translate(' + (dx * 6).toFixed(1) + 'px,' + (dy * 5).toFixed(1) + 'px)';
    cur = b;
  }, { passive: true });
  document.addEventListener('pointerout', function (e) {
    if (cur && !cur.contains(e.relatedTarget)) { cur.style.transform = ''; cur = null; }
  }, { passive: true });
})();

/* Fly-to-cart: a gloss-pink drop arcs from the pressed add button into
   the bag icon. Decoration only — the add itself never depends on it. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function fly(fromEl) {
    if (!fromEl || document.documentElement.classList.contains('gmj-fx-paused')) return;
    var target = document.getElementById('cart-icon-bubble');
    if (!target) return;
    var a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width || !b.width) return;
    var d = document.createElement('span');
    d.className = 'gmj-fly';
    d.style.left = (a.left + a.width / 2 - 7) + 'px';
    d.style.top = (a.top + a.height / 2 - 7) + 'px';
    document.body.appendChild(d);
    setTimeout(function () {
      d.style.transform = 'translate(' + (b.left + b.width / 2 - (a.left + a.width / 2)) + 'px,'
        + (b.top + b.height / 2 - (a.top + a.height / 2)) + 'px) scale(.3)';
      d.style.opacity = '0';
    }, 20);
    setTimeout(function () { d.remove(); }, 800);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.product-form__submit, .quick-add__submit, .gmj-stickybuy__btn');
    if (b && !b.disabled && b.getAttribute('aria-disabled') !== 'true') fly(b);
  });
  document.addEventListener('submit', function (e) {
    if (e.target.classList && e.target.classList.contains('gmj-qa-form')) {
      fly(e.target.querySelector('[type=submit]'));
    }
  });
})();

/* Nav-link word roll: on hover the whole menu word glides up and is
   replaced by itself — one calm motion, no letter gimmicks. The link
   keeps its accessible name; the doubled word is presentation only. */
(function () {
  if (!window.matchMedia('(any-pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('.header__menu-item').forEach(function (link) {
    var span = link.querySelector('span');
    if (!span || span.children.length) return;
    var text = span.textContent.trim();
    if (!text || text.length > 28) return;
    if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', text);
    span.textContent = '';
    span.classList.add('gmj-wr');
    span.setAttribute('aria-hidden', 'true');
    var inner = document.createElement('span');
    inner.className = 'gmj-wr-in';
    var a = document.createElement('b'); a.textContent = text;
    var b = document.createElement('b'); b.textContent = text;
    inner.appendChild(a); inner.appendChild(b);
    span.appendChild(inner);
  });
})();

/* Restock notify: Shopify's invisible captcha swallows customer-form
   submits without navigating (same quirk as the countdown signup), so
   success is shown by the click itself after a beat — the signup is
   recorded server-side either way. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.gmj-restock__form button');
  if (!btn) return;
  var box = btn.closest('.gmj-restock');
  var email = box && box.querySelector('input[type=email]');
  if (!email || !email.value || !email.checkValidity()) return;
  setTimeout(function () {
    var form = box.querySelector('.gmj-restock__form');
    var ok = box.querySelector('.gmj-restock__ok');
    if (form) form.hidden = true;
    if (ok) { ok.hidden = false; ok.focus(); }
  }, 1800);
}, true);

/* Quick-add without the takeover: grid and collection add-to-bag forms
   add via AJAX and refresh the drawer + badge IN PLACE — the drawer does
   NOT open, so the flying drop and the rolling count stay visible and
   the shopper keeps browsing. (Dawn's renderContents force-opens the
   drawer, so the section HTML is applied by hand here.) The product
   page's own Add to bag still opens the drawer — that one is a
   deliberate act. Any failure falls back to a normal form submit. */
(function () {
  /* Speak to the cart live region. Dawn's cart.js is the only other writer and it
     sits on the path we bypass, so quick-add would otherwise announce nothing. */
  function gmjSay(msg) {
    var lr =
      document.getElementById('CartDrawer-LiveRegionText') ||
      document.getElementById('cart-live-region-text');
    if (!lr) return;
    lr.textContent = '';
    setTimeout(function () { lr.textContent = msg; }, 60);
  }
  /* Show a failure inline, sanitised, without leaving the page. */
  function gmjQaError(form, description) {
    var generic =
      (window.variantStrings && window.variantStrings.quantityUnavailable) ||
      'Sorry, that could not be added right now.';
    var msg = description && !/\d/.test(description) ? description : generic;
    var slot = form.querySelector('.gmj-qa-err');
    if (!slot) {
      slot = document.createElement('p');
      slot.className = 'gmj-qa-err';
      slot.setAttribute('role', 'status');
      form.appendChild(slot);
    }
    slot.textContent = msg;
    gmjSay(msg);
  }
  function applySections(state) {
    if (!state || !state.sections) return;
    var dp = new DOMParser();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && state.sections['cart-drawer']) {
      var doc = dp.parseFromString(state.sections['cart-drawer'], 'text/html');
      var nInner = doc.querySelector('.drawer__inner');
      var cInner = drawer.querySelector('.drawer__inner');
      if (nInner && cInner) cInner.innerHTML = nInner.innerHTML;
      drawer.classList.remove('is-empty');
      if (cInner) cInner.classList.remove('is-empty');
    }
    var bub = document.getElementById('cart-icon-bubble');
    if (bub && state.sections['cart-icon-bubble']) {
      var bdoc = dp.parseFromString(state.sections['cart-icon-bubble'], 'text/html');
      var src = bdoc.getElementById('cart-icon-bubble') || bdoc.querySelector('.shopify-section') || bdoc.body;
      bub.innerHTML = src.innerHTML; /* badge observer sees this → pop + roll */
    }
    gmjSay('Added to your bag');
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !window.Shopify) return;
    var isGmj = form.classList && form.classList.contains('gmj-qa-form');
    /* Dawn's product-form.js owns .quick-add__submit forms. It replaces any numeric
       error description with variantStrings.quantityUnavailable, because Shopify's
       message can state the exact units on hand and stock counts are never shown.
       Intercepting it bypassed that guard, so we no longer do. */
    if (!isGmj) return;
    e.preventDefault();
    e.stopPropagation(); /* capture phase — runs before Dawn's product-form */
    var btn = form.querySelector('[type=submit]');
    if (btn) btn.setAttribute('aria-disabled', 'true');
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer,cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);
    fetch(window.Shopify.routes.root + 'cart/add', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        /* Never hand off to a native submit: it lands on Shopify's unstyled error
           page carrying an untrimmed description that can name the stock count. */
        if (state.status) { gmjQaError(form, state.description); return; }
        applySections(state);
      })
      .catch(function () {
        /* A network blip after a server-side success would double-add on resubmit. */
        gmjQaError(form, null);
      })
      .finally(function () { if (btn) btn.removeAttribute('aria-disabled'); });
  }, true);
})();

/* v2 port: word-by-word heading reveals. Splits .gmj .gmj-head h2 into
   per-word masks; the reveal observer above adds .is-in to .gmj-head,
   and gmj-cards.css staggers the words up. Owner's call, 22 Aug. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('.gmj .gmj-head h2').forEach(function (h) {
    if (h.dataset.v2split || h.children.length) return;
    var words = h.textContent.trim().split(/\s+/);
    if (!words.length || words.length > 12) return;
    h.dataset.v2split = '1';
    h.setAttribute('aria-label', words.join(' '));
    h.textContent = '';
    words.forEach(function (w, i) {
      var mask = document.createElement('span');
      mask.className = 'gmj-v2w';
      mask.setAttribute('aria-hidden', 'true');
      var inner = document.createElement('span');
      inner.style.setProperty('--wi', i);
      inner.textContent = w;
      mask.appendChild(inner);
      h.appendChild(mask);
      if (i < words.length - 1) h.appendChild(document.createTextNode(' '));
    });
  });
})();

/* Micro effects F + G (22 Aug): lazy-image fade-in; heart pulse in the announcement bar. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
    if (img.complete) return;
    img.classList.add('gmj-img-in');
    var reveal = function () { img.classList.add('is-loaded'); };
    img.addEventListener('load', reveal, { once: true });
    img.addEventListener('error', reveal, { once: true });
    /* An image can finish between the complete check above and the listener
       attaching. The load event has already fired by then and never fires
       again, so re-check here or it stays at opacity 0 until the fallback. */
    if (img.complete) { reveal(); return; }
    /* Fallback for an image that neither loads nor errors. 2.5s of an
       invisible-but-present image reads as broken -- it is why the Shade of
       the Week block was repeatedly reported as "not showing". */
    setTimeout(reveal, 800);
  });
  /* Every heart on the page beats: wrap heart chars found in text nodes. */
  var heartRx = new RegExp('([' + '♡♥❤❥✦✧⋆✨' + '])', 'g');
  var isHeartCh = new RegExp('[' + '♡♥❤❥' + ']');
  function gmjWrapGlyphs() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        heartRx.lastIndex = 0;
        if (!heartRx.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        var el = n.parentElement;
        if (!el || el.closest('script,style,textarea,svg,.gmj-heart-pulse,.gmj-spark-pulse,.gmj-qs,.gmj-hero-sparks')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var heartNodes = [];
    while (walker.nextNode()) heartNodes.push(walker.currentNode);
    heartNodes.forEach(function (n) {
      heartRx.lastIndex = 0;
      var frag = document.createDocumentFragment();
      n.nodeValue.split(heartRx).forEach(function (part, i) {
        if (!part) return;
        if (i % 2) {
          var h = document.createElement('span');
          h.className = isHeartCh.test(part) ? 'gmj-heart-pulse' : 'gmj-spark-pulse';
          h.textContent = part;
          frag.appendChild(h);
        } else {
          frag.appendChild(document.createTextNode(part));
        }
      });
      n.parentNode.replaceChild(frag, n);
    });
  }
  gmjWrapGlyphs();
  /* Judge.me injects review text after load - sweep again for late glyphs. */
  setTimeout(gmjWrapGlyphs, 3000);
  setTimeout(gmjWrapGlyphs, 7000);
})();

/* ---- Optimistic bag count (27 Aug) --------------------------------------
   MEASURED: /cart/add takes 1094-1231ms, TTFB ~1100ms, because Shopify renders
   cart-drawer and cart-icon-bubble server-side and returns ~22KB. At 1s after a
   click the badge still read 0 and the drawer was shut. Nothing on screen moved
   for that whole second, which is why add-to-bag was repeatedly reported as
   slow -- "slow till the bag opens and till the number shows".

   This does not make the request faster. It answers the shopper immediately and
   lets the real server count overwrite a second later, so a failed add
   self-corrects instead of leaving a wrong number on screen.

   Both paths were prototyped in the live console before shipping:
     stocked cart 3->4->6, and with a STRING input, 6->7 (not "61")
     empty cart   0 bubbles -> creates exactly 1 -> 0->1->2, still 1 bubble
   The first attempt at this shipped and was reverted: it did n + by with `by`
   still a string, so the badge read "23" instead of "3". Hence Number() on both
   sides and String() on the write -- do not simplify these away. */
(function () {
  function bumpBadge(by) {
    var wrap = document.getElementById('cart-icon-bubble');
    if (!wrap) return;
    var bubble = wrap.querySelector('.cart-count-bubble');
    if (!bubble) {
      /* An empty cart renders no bubble at all, so the first add must build one. */
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true">0</span><span class="visually-hidden"></span>';
      wrap.appendChild(bubble);
    }
    var span = bubble.querySelector('span[aria-hidden="true"]');
    if (!span) return;
    var n = Number(String(span.textContent).replace(/\D/g, '')) || 0;
    var add = Number(by) || 1;
    span.textContent = String(n + add);
    var vh = bubble.querySelector('.visually-hidden');
    if (vh) vh.textContent = (n + add) + ' items';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var qty = form.querySelector('input[name="quantity"]');
    bumpBadge(qty ? qty.value : 1);
  }, false); /* bubble phase, after the handler that actually sends the request */
})();
